// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.system_state {\n  padding: 10px;\n}\n.card_item {\n  height: 280px;\n}\n", ""]);
// Exports
module.exports = exports;
